import { render } from "./table-tree.vue?vue&type=template&id=e6ed1236"
import script from "./table-tree.vue?vue&type=script&lang=js"
export * from "./table-tree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__